module.exports = __webpack_public_path__ + "img/Logo TR Search Engine & Wiki.489cff75.png";